<main *transloco="let t">
  <section class="wallpaper"></section>

  <section class="login">
    <!-- Loading state -->
    @if (status() === 'loading') {
      <div class="state-wrapper">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="state-text">{{ t('Confirming your email...') }}</p>
      </div>
    }

    <!-- Success state -->
    @if (status() === 'success') {
      <div class="state-wrapper">
        <div class="logo-wrapper"><p class="logo"></p></div>

        <div class="icon-circle success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 12l5 5 9-9"
              stroke="#ffffff"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <h2>{{ t('Email Confirmed!') }}</h2>

        <p class="description">
          {{
            t(
              'Your email has been successfully verified. Your account is now active.'
            )
          }}
        </p>

        <p class="countdown">
          {{ t('Opening the app in') }} <strong>{{ countdown() }}</strong>
          {{ t('seconds.') }}
        </p>

        <button class="open-app-btn" (click)="openApp()">
          {{ t('Open App') }}
        </button>

        <p class="hint">
          {{ t("If the app doesn't open, make sure you have it installed.") }}
        </p>
      </div>
    }

    <!-- Error state -->
    @if (status() === 'error') {
      <div class="state-wrapper">
        <div class="logo-wrapper"><p class="logo"></p></div>

        <div class="icon-circle error-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="#ffffff"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <h2>{{ t('Confirmation Failed') }}</h2>
        <p class="description error-text">{{ errorMessage() }}</p>
      </div>
    }
  </section>
</main>
